import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { UserAuthenticationService } from '../_services/authentication.service';
import { Observable } from 'rxjs';
import { Helpers } from '../../../helpers';
import { DataService } from '../../../_services/data.service';

@Injectable()
export class UserAuthGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _authenticationService: UserAuthenticationService,
        private dataService: DataService
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | boolean {
        var path = Helpers.getPath();
        let authData = this.dataService.getAuthData();
        if (authData && authData.token) {
            return true;
        }
        this._router.navigate(['/owner/login'], {
            queryParams: { returnUrl: state.url }
        });
        return false;

        // return this._authenticationService.verify().map(
        //     data => {
        //         if (data !== null) {
        //             return true;
        //         }
        //         this._router.navigate(['/owner/login'], { queryParams: { returnUrl: state.url } });
        //         return false;
        //     },
        //     error => {
        //         this._router.navigate(['/owner/login'], { queryParams: { returnUrl: state.url } });
        //         return false;
        //     });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/user/_guards/auth.guard.ts